import shopping from './img/ShoppingCart.png';
import trivia from './img/trivia.png';
import tryunfo from './img/tryunfo.png';
import wallet from './img/wallet.png';
import tunes from './img/tunes.png';
import solar from './img/req-1.png';

const products = [
    {
      id: 1,
      img: shopping
    },
    {
        id: 2,
        img: trivia
    },
    {
        id: 3,
        img: tryunfo
    },
    {
        id: 4,
        img: wallet
    },
    {
        id: 5,
        img: tunes
    },
    {
        id: 6,
        img: solar
    },
]

export default products;
